<template>
  <v-container>
    <div>
      <h1>Datensatz mit Überlagerungen</h1>
      <p>Dieser Datensatz beinhaltet die Flächen, welche die Bebaurbarkeit auf verschiedene Weise beeinflussen. Der Datensatz erhöht grundsätzlich die Genauigkeit der Berechnung, wenn z.B. die Gewässerräume enthalten sind. Die einzelnen Parameter für die Definition (wie z. B. Abstand zum Gewässeraum usw.) sind nicht im Datensatz erforderlich und können direkt später in der Anwendung editiert oder erfasst werden. Die Parameter können mitgeliefert werden, falls diese bereits in den Daten vorhanden sind.</p>
      <p><b>Datenquelle</b><br />GIS-Dienstleister / Raumplaner</p>
      <p><b>Format</b><br />Shape-File (.shp) mit allen dazugehörigen formatspezifischen Dateien (.prj, .dbf, .shx, optional .cpg). Alle Dateien müssen in einem ZIP-File komprimiert und hochgeladen werden.<br />Koordinatensystem: Swiss CH1903+ / LV95; EPSG: 2056</p>
          <p>
            <v-simple-table>
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">
                    Name
                </th>
                <th class="text-left">
                    Beschreibung
                </th>
                <th class="text-left">
                    Einheit
                </th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="item in attributes"
                :key="item.name"
                >
                <td>{{ item.name }}</td>
                <td>{{ item.desc }}</td>
                <td>{{ item.unit }}</td>
                </tr>
            </tbody>
            </template>
                  </v-simple-table>
          </p>
      <!-- <p>TODO Download Beispieldatensatz</p> -->
    </div>
  </v-container>

</template>

<script>
export default {
  name: 'DocStr',
  data () {
    return {
      attributes: [
        {
          name: 'geom',
          desc: 'Die Geometrie der überlagernden Flächen.',
          unit: 'Polygon/Multipolygon'
        },
        {
          name: 'bezeichn',
          desc: 'Bezeichnung der Zone in voller Länge.\nZ.B. \'Wohn- und Arbeitszone A\'',
          unit: 'Text (max. 100 Zeichen)'
        },
        {
          name: 'rednutz',
          desc: 'Reduktion der Grundnutzung in %. Standardwert: 0',
          unit: 'Boolean'
        },
        {
          name: 'abstand',
          desc: 'Abstand der Bauten in Meter. Standartwert: 0',
          unit: 'Boolean'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/docs/DocOvl.vue